import { createBrowserRouter, Navigate } from 'react-router-dom';

// 直接导入页面组件（不使用懒加载）
import Login from './pages/login';
import MainLayout from './layouts/MainLayout';
import OnboardingLayout from './layouts/OnboardingLayout';

// Onboarding pages
import OnboardingName from './pages/onboarding/OnboardingName';
import OnboardingProfile from './pages/onboarding/OnboardingProfile';

// Dashboard pages
import Dashboard from './pages/dashboard/Dashboard';
import MySongs from './pages/dashboard/MySongs';
import MyAlbums from './pages/dashboard/MyAlbums';
import EditProfile from './pages/dashboard/EditProfile';

// Release Song pages
import ReleaseType from './pages/release/ReleaseType';
import ReleaseUpload from './pages/release/ReleaseUpload';
import ReleaseBasicInfo from './pages/release/ReleaseBasicInfo';
import ReleaseAdvanced from './pages/release/ReleaseAdvanced';
import ReleaseSchedule from './pages/release/ReleaseSchedule';
import ReleaseSuccess from './pages/release/ReleaseSuccess';

// Album pages
import { AlbumCreate, AlbumEditReorder, AlbumSchedule, AlbumSuccess, EditAlbum, AlbumInfo } from './pages/album';

// Song pages
import { EditSong } from './pages/song';

// Home page  
import Home from './pages/home';

// Route constants
export const ROUTES = {
  // Home（根路径由服务端静态 homepage.ejs 渲染）
  home: '/',

  // Auth
  login: '/login',
  
  // Onboarding
  onboarding: '/onboarding',
  onboardingName: '/onboarding/name',
  onboardingProfile: '/onboarding/profile',
  
  // Dashboard (在 /app 下)
  dashboard: '/app/dashboard',
  mySongs: '/app/my-songs',
  myAlbums: '/app/my-songs/albums',
  editProfile: '/app/edit/profile',
  
  // Release Song Flow (先选类型 -> 上传 -> 基本信息 -> 高级 -> 发布时间 -> 成功)
  release: '/app/release',
  releaseType: '/app/release/type',
  releaseUpload: '/app/release/upload',
  releaseBasicInfo: '/app/release/basic',
  releaseAdvanced: '/app/release/advanced',
  releaseSchedule: '/app/release/schedule',
  releaseSuccess: '/app/release/success',
  
  // Album Flow (创建专辑 -> 添加歌曲 -> 编辑排序 -> 发布时间 -> 成功)
  albumCreate: '/app/album/create',
  albumEditReorder: '/app/album/edit-reorder',
  albumSchedule: '/app/album/schedule',
  albumSuccess: '/app/album/success',

  // Song Edit (不使用动态路由，数据通过 sessionStorage 传递)
  editSong: '/app/song/edit',

  // Album Edit & Info (不使用动态路由，数据通过 sessionStorage 传递)
  albumInfo: '/app/album/info',
  editAlbum: '/app/album/edit',
} as const;

// Router configuration
export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/onboarding',
      element: <OnboardingLayout />,
      children: [
        { index: true, element: <Navigate to="name" replace /> },
        { path: 'name', element: <OnboardingName /> },
        { path: 'profile', element: <OnboardingProfile /> },
      ],
    },
    {
      path: '/app',
      element: <MainLayout />,
      children: [
        { index: true, element: <Navigate to="/app/dashboard" replace /> },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'my-songs', element: <MySongs /> },
        { path: 'my-songs/albums', element: <MyAlbums /> },
        { path: 'edit/profile', element: <EditProfile /> },
        // Release Song 流程
        { path: 'release', element: <Navigate to="/app/release/type" replace /> },
        { path: 'release/type', element: <ReleaseType /> },
        { path: 'release/upload', element: <ReleaseUpload /> },
        { path: 'release/basic', element: <ReleaseBasicInfo /> },
        { path: 'release/advanced', element: <ReleaseAdvanced /> },
        { path: 'release/schedule', element: <ReleaseSchedule /> },
        { path: 'release/success', element: <ReleaseSuccess /> },
        // Album 流程
        { path: 'album/create', element: <AlbumCreate /> },
        { path: 'album/edit-reorder', element: <AlbumEditReorder /> },
        { path: 'album/schedule', element: <AlbumSchedule /> },
        { path: 'album/success', element: <AlbumSuccess /> },
        // Song Edit (数据通过 sessionStorage 传递)
        { path: 'song/edit', element: <EditSong /> },
        // Album Info & Edit (数据通过 sessionStorage 传递)
        { path: 'album/info', element: <AlbumInfo /> },
        { path: 'album/edit', element: <EditAlbum /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

export default router;
